<template>
  <div>
    <div class="contents">
      <b-form
        @submit="onSubmit"
        class="filter-group row row-cols-1 row-cols-xl-auto g-2"
      >
        <div class="col col-xl-4">
          <div class="date-search">
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.startdate"
            />
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.enddate"
            />
          </div>
        </div>

        <div class="col col-xl-8">
          <div class="row g-2">
            <div class="col-6 col-sm-3 col-md-auto">
              <select class="form-select" v-model="searchData.type">
                <option value="0">{{ $t("filter.common.total") }}</option>
                <option value="1">{{ $t("filter.event.holeinone") }}</option>
                <option value="2">{{ $t("filter.event.albatross") }}</option>
                <option value="3">{{ $t("filter.event.eagle_p5") }}</option>
                <option value="4">{{ $t("filter.event.birdie_p5") }}</option>
                <option value="5">{{ $t("filter.event.par_p5") }}</option>
                <option value="6">{{ $t("filter.event.eagle_p4") }}</option>
                <option value="7">{{ $t("filter.event.birdie_p4") }}</option>
                <option value="8">{{ $t("filter.event.par_p4") }}</option>
                <option value="9">{{ $t("filter.event.longest") }}</option>
                <option value="10">{{ $t("filter.event.nearpin") }}</option>
                <option value="11">
                  {{ $t("filter.event.longest_rank") }}
                </option>
                <option value="12">
                  {{ $t("filter.event.nearpin_rank") }}
                </option>
              </select>
            </div>

            <div class="col-6 col-sm-3 col-md-auto">
              <select class="form-select" v-model="searchData.searchtype">
                <option value="1">
                  {{ $t("filter.common.title") }}
                </option>
                <option value="2">{{ $t("filter.common.course") }}</option>
                <option value="3">{{ $t("filter.common.winner") }}</option>
              </select>
            </div>

            <div class="col">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchData.searchname"
                />
                <button
                  class="btn btn-primary btn-lg icon-search"
                  type="submit"
                  value=""
                ></button>
              </div>
            </div>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xxxl">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.number") }}
            </th> -->
            <!-- <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.minigame") }} {{ $t("title.common.type") }}
            </th> -->
            <th class="col-auto">
              {{ $t("title.common.winner") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.title") }}
            </th>
            <!-- <th class="col-auto d-none d-xxxl-table-cell">Simulator No.</th> -->
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.prizes") }}
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.golfcourse.distance") }}
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.standard_point") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-xxxl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <!-- <th class="col-auto d-none d-xxxl-table-cell">Control</th> -->
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <!-- <td class="col-auto d-none d-xxxl-table-cell">{{ item.no }}</td> -->
              <!-- <td class="col-auto d-none d-xxxl-table-cell">
                {{ event_type(item.type) }}
              </td> -->
              <td class="col-auto text-start">
                <MemberInfo
                  :nickname="item.nickname"
                  :playerno="item.playerno"
                  :member_img="item.member_img"
                  :badge_img="item.badge_img"
                  :displayText="item.nickname || item.playerid"
                />
              </td>
              <td class="col-auto text-start text-black">
                <!-- <span class="badge minigame-type">
                  {{ item.awardtype | awardtype }}
                </span> -->
                <span class="badge minigame-event-type">
                  {{ event_type(item.type) }}
                </span>
                <p class="minigame-title">{{ item.title }}</p>
              </td>
              <!-- <td class="col-auto d-none d-xxxl-table-cell">
                {{ item.simulatorno }}
              </td> -->
              <td class="col-auto d-none d-md-table-cell">
                {{ item.coursename }} {{ item.subcoursename }}({{ item.hole }}H)
              </td>
              <td class="col-auto d-none d-xxxl-table-cell text-prize">
                {{ item.type < 11 ? null || item.point : "Rank Prize" }}
              </td>
              <td class="col-auto d-none d-xxxl-table-cell">
                <template v-if="item.record">{{ item.record }}m</template>
                <template v-else>-</template>
              </td>
              <td class="col-auto d-none d-xxxl-table-cell text-point-sp">
                <template v-if="item.standard_points > 0">
                  {{ item.standard_points | comma | suffix("P") }}
                </template>
                <template v-else> - </template>
              </td>
              <td class="col-auto d-none d-xl-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="col-auto d-none d-xxxl-table-cell shop-name">
                {{ item.shopname }}
              </td>
              <!-- <td class="col-auto d-none d-xxxl-table-cell">
                <button
                  type="button"
                  class="btn btn-primary btn-xs"
                  @click="
                    $router.push({
                      name: 'MiniGameRank',
                      params: {
                        params: { eventno: item.eventno },
                      },
                    })
                  "
                >
                  {{ $t("participant") }}
                </button>
              </td> -->
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="8">
                <div class="toggle-content">
                  <!-- <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.minigame") }}
                      {{ $t("title.common.type") }}
                    </div>
                    <div class="col-8">{{ event_type(item.type) }}</div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-4">{{ $t("title.common.winner") }}</div>
                    <div class="col-8">
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.playerno"
                        :displayText="item.nickname || item.playerid"
                      />
                    </div>
                  </div> -->
                  <!-- <div class="row">
                    <div class="col-4">Simulator No.</div>
                    <div class="col-8">{{ item.simulatorno }}</div>
                  </div> -->
                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.course") }}</div>
                    <div class="col-8">
                      {{ item.coursename }} {{ item.subcoursename }}
                    </div>
                  </div>

                  <div class="row d-md-none">
                    <div class="col-4">{{ $t("title.common.hole") }}</div>
                    <div class="col-8">{{ item.hole }}H</div>
                  </div>

                  <div class="row">
                    <div class="col-4">{{ $t("title.common.prizes") }}</div>
                    <div class="col-8 text-prize">
                      {{ item.type < 11 ? null || item.point : "Rank Prize" }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.golfcourse.distance") }}
                    </div>
                    <div class="col-8" v-if="item.record">
                      {{ item.record }}m
                    </div>
                    <div class="col-8" v-else>-</div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      <template v-if="item.standard_points > 0">
                        {{ item.standard_points | comma }}P
                      </template>
                      <template v-else> - </template>
                    </div>
                  </div>

                  <div class="row d-xl-none">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>

                  <div class="row d-xxxl-none">
                    <div class="col-4">{{ $t("title.common.location") }}</div>
                    <div class="col-8 shop-name">
                      {{ item.shopname }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-4">Control</div>
                    <div class="col-8">
                      <button
                        type="button"
                        v-if="item.type > 10"
                        class="btn btn-primary btn-xs"
                        @click="
                          $router.push({
                            name: 'MiniGameRank',
                            params: {
                              params: { eventno: item.eventno },
                            },
                          })
                        "
                      >
                        {{ $t("participant") }}
                      </button>
                    </div>
                  </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import ax from "@/api/event";
import { myMixin } from "@/mixin/myMixin";
import "@/filter/common";

export default {
  name: "MiniGameWinningList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs().add(-1, "month").format("YYYY-MM-DD"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        type:
          this.$route.query.type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].type) ||
          0,
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        eventno: this.$route.params.eventno || 0,
      },

      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_admineventwinninglist();
    },
    get_admineventwinninglist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_admineventwinninglist(this.searchData, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          if (data.eventwvinninglistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.eventwvinninglistcnt;
          this.page_total = Math.ceil(data.eventwvinninglistcnt / this.rows);
          this.items = data.eventwvinninglist;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_admineventwinninglist();
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.get_admineventwinninglist();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.get_admineventwinninglist();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_admineventwinninglist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_admineventwinninglist();
    },
    "searchData.type": function () {
      this.searchData.pageno = 1;
      this.get_admineventwinninglist();
    },
    "searchData.pageno": function () {
      this.get_admineventwinninglist();
    },
  },

  mixins: [myMixin],
};
</script>
